import { PriceRange } from "@adobe-commerce/elsie/components";
import { Product } from "@/plp/data/models/product";
import '@/plp/components/ProductList/ProductList';

export const SimpleProductPrice = ({ product }: { product: Product }) => {
  let currency = product.price?.regular?.amount?.currency ?? "USD";

  if (!Intl.supportedValuesOf("currency").includes(currency)) {
    currency = "USD";
  }


  const finalAmount = product.price?.final?.amount?.value;
  const regularAmount = product.price?.regular?.amount?.value;

  const hasSpecial =
    finalAmount !== undefined &&
    regularAmount !== undefined &&
    finalAmount < regularAmount;

  if (!hasSpecial) {
    return <PriceRange amount={regularAmount} currency={currency} />;
  }

  return (
    <div class="product-price">
      <span class="regular-price-normal">
        <PriceRange amount={finalAmount} currency={currency} />
      </span>
      <span class="special-price-crossed">
        <PriceRange amount={regularAmount} currency={currency} />
      </span>
    </div>
  );
};
